import React from 'react';
import {filter, find, map, pathOr} from 'ramda';
import classNames from 'classnames';
import {FormattedMessage} from "react-intl";

import css from './style.css';
import {isNilOrEmpty} from '../../util/validators';
import CartListingCard from '../../components/CartListingCard/ListingCard';
import ExtraPanel from "./LisitngPriceDetailsModal/ExtraPanel/ExtraPanel";

const ExtrasContent = props => {
  const {
    intl,
    currentUserSwimPlusLevel,
    discount,
    renderSizes,
    handleOpenListingPriceDetailsModal,
    hasSelectedSwimPlus,
    listings,
    selectedExtrasByListings,
    setSelectedExtrasByListings,
  } = props;
  const sortedListings = [
    ...filter((listing) => !isNilOrEmpty(pathOr([], ['attributes', 'publicData', 'paidExtrasData'], listing)), listings),
    ...filter((listing) => isNilOrEmpty(pathOr([], ['attributes', 'publicData', 'paidExtrasData'], listing)), listings),
  ]
  const handleSaveExtras = (extras) => {
    setSelectedExtrasByListings(extras);
  };
  const renderListingExtras = (listing) => {
    const paidExtrasData = pathOr([], ['attributes', 'publicData', 'paidExtrasData'], listing);
    return (
      <div className={css.listingExtrasContainer}>
        <CartListingCard
          key={listing.id.uuid}
          listing={listing}
          renderSizes={renderSizes}
          handleOpenDetails={() => handleOpenListingPriceDetailsModal(listing)}
          selectedExtras={selectedExtrasByListings[listing.id.uuid]}
          swimPlusLevel={isNilOrEmpty(discount) && (currentUserSwimPlusLevel || (hasSelectedSwimPlus ? 1 : 0))}
          isPurchasingSwimPlus={!currentUserSwimPlusLevel && hasSelectedSwimPlus}
          small
        />
        {!isNilOrEmpty(paidExtrasData) ? (
          <ExtraPanel
            // className={css.extraPanel}
            intl={intl}
            exposeSelectedExtras={handleSaveExtras}
            handleSubmit={handleSaveExtras}
            paidExtrasData={paidExtrasData}
            selectedExtrasByListings={selectedExtrasByListings}
            setSelectedExtrasByListings={setSelectedExtrasByListings}
            listingId={listing?.id?.uuid}
            light
          />
        ) : (
          <p className={css.listingsExtrasDescription}>
            <FormattedMessage
              id={"CheckoutExtraPage.ListingsExtrasSection.noExtras"}/>
          </p>
        )}
      </div>
    )
  }

  return (
    <div>
      <p className={css.listingsExtrasDescription}>
        <FormattedMessage
          id={"CheckoutExtraPage.ListingsExtrasSection.panelInfo"}/>
      </p>
      <div className={classNames(css.listingsContent, css.extrasSection)}>
        <div className={css.listingCards}>
          {sortedListings.map(renderListingExtras)}
        </div>
      </div>
    </div>
  );
};

export default ExtrasContent;
